var map = {
	"./img_1.jpg": 94058,
	"./img_2.png": 20177,
	"./img_3.png": 69648,
	"./img_4.png": 98120,
	"./img_5.jpg": 16144,
	"./img_6.jpg": 12769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71373;